import { Text } from "pixi.js";
import Layers from "slotworks/graphics/layers/layers";
import Contract from "slotworks/utils/contract";
import { Tween } from "slotworks/utils/tween";

export default class FreespinsMeterComponent {

    public static readonly FREESPINS_X_OF_Y_VALUE = "freespins_x_of_y_value";

    private layer: Layers;
    private freespinsXOfyText: Text;

    private totalFreeSpins: number = 0;
    private remainingFreespins: number = 0;

    constructor() {
        this.layer = Layers.Banners;
        this.layer.onSceneEnter.add((scene: string) => {
            if (scene === "freespins") {
                this.setup();
            }
        });
    }

    public setTotalFreespins(value: number) {
        this.totalFreeSpins = value;
        this.updateField();
    }

    public setRemainingFreespins(value: number) {
        this.remainingFreespins = value;
        this.updateField();
    }

    public countUp(totalFreeSpins: number) {
        return new Contract(resolve => {
            const obj = { total: this.totalFreeSpins };
            const played = (this.totalFreeSpins - this.remainingFreespins);
            new Tween(obj)
                .to({ total: totalFreeSpins }, 200)
                .onUpdate(() => {
                    const total = Math.floor(obj.total);
                    this.freespinsXOfyText.text = played + "/" + total;
                })
                .onComplete(resolve)
                .start();
        })
    }

    private setup() {
        this.freespinsXOfyText = this.layer.getText(FreespinsMeterComponent.FREESPINS_X_OF_Y_VALUE);
        this.updateField();
    }

    private updateField() {
        if (this.freespinsXOfyText) {
            if (this.totalFreeSpins > 0) {
                this.freespinsXOfyText.text = (this.totalFreeSpins - this.remainingFreespins) + "/" + this.totalFreeSpins;
            } else {
                this.freespinsXOfyText.text = "";
            }
        }
    }
}